var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3,55.9l-3.6-1a30.4,30.4,0,1,0-49.4,0l-3.6,1c-11.4,3.3-15,13.7-15,19.9v4.4A13.1,13.1,0,0,0,19.8,93.3H80.2A13.1,13.1,0,0,0,93.3,80.2V75.8c0-6.1-3.5-16.6-15-19.9ZM50,14.8A22.4,22.4,0,1,1,27.7,37.1,22.3,22.3,0,0,1,50,14.8ZM85.2,80.2a5.1,5.1,0,0,1-5,5H19.8a5.1,5.1,0,0,1-5-5V75.8a12.6,12.6,0,0,1,9.1-12.1l7.8-2.2a30.5,30.5,0,0,0,36.6,0l7.8,2.2a12.6,12.6,0,0,1,9.1,12.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7ee2ecac.svg";
export { ForwardRef as ReactComponent };